import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  '@global': {
    '@keyframes shine': {
      from: {
        right: '-75%',
      },
      to: {
        right: '125%',
      },
    },
  },
  root: {
    [theme.breakpoints.down('md')]: {
      // marginInlineEnd: theme.spacing(-2)
    },
  },
  buttonProgress: {
    margin: 'auto',
  },
  paper: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    margin: 0,
    boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
    border: 'solid 1px #e7e7f1',
    borderTopColor: 'transparent',
  },
  mainButton: {
    backgroundColor: '#f7f8f8',
    minWidth: 170,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0)',
    border: 'solid 1px transparent',
    '&:hover, &.active': {
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
      borderColor: '#e7e7f1',
      borderBottomColor: 'transparent',
    },
    '&.active': {
      backgroundColor: '#f7f8f8',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    '& .MuiButton-endIcon': {
      marginInlineStart: 'auto',
      flexShrink: 0,
    },
    '& .MuiButton-startIcon': {
      flexShrink: 0,
    },
    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
    },
  },
  activeButton: {},
  popper: {
    marginInlineStart: -2,
    [theme.breakpoints.down('md')]: {
      minWidth: 170,
      right: `${theme.spacing(1.4)} !important`,
    },
  },
  bizDetail: {
    backgroundColor: '#f7f8f8',
    marginTop: -1,
    borderBottom: 'solid 1px #e7e7f1',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    marginInlineStart: -2,
    width: '167px',
    [theme.breakpoints.down('md')]: {
      borderTop: 'solid 1px #e7e7f1',
      paddingTop: theme.spacing(1),
      borderTopLeftRadius: 4,
    },
  },
  detailItem: {
    fontSize: 10,
    textAlign: 'left',
    cursor: 'pointer',
    padding: `${theme.spacing(0.3)} ${theme.spacing(1.5)}`,
    '& span': {
      float: 'right',
    },
  },
  menuItem: {
    fontSize: 11,
    paddingInlineStart: theme.spacing(1.5),
    gap: 5,

  },
  menuIcon: {
    fontSize: 17,
    marginInlineEnd: theme.spacing(1),
  },
  bizEnName: {
    color: '#37474f',
    fontSize: 10,
    textAlign: 'right',
    position: 'absolute',
    top: 20,
    zIndex: 11,
    opacity: 0,
    transition: 'ease opacity .25s',
    fontFamily: 'Vazir',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    overflowWrap: 'break-word',
    direction: 'rtl',
    '&.show': {
      opacity: 1,
    },
  },
  avatar: {
    width: 25,
    height: 25,
    background: 'transparent',
    [theme.breakpoints.down('md')]: {
      marginInlineEnd: theme.spacing(-1),
    },
  },
  avatarLoading: {
    width: 25,
    height: 25,
    [theme.breakpoints.down('md')]: {
      marginInlineEnd: theme.spacing(-1),
    },
  },
  normalTitleContainer: {
    width: 'auto',
    minWidth: 0,
    flex: '1 1 auto',
    textAlign: 'left',
    position: 'relative',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    overflowWrap: 'break-word',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  tooltip: {
    // marginTop: -5
  },
}));

export const useStylesTopbar = makeStyles((theme) => {
  return {
    root: {
      boxShadow: '0 1px 2px 0 rgba(38, 50, 56, 0.2)',
      backgroundColor: '#ffffff',
      paddingInlineStart: theme.spacing(2),
      paddingInlineEnd: theme.spacing(2),
      flexDirection: 'row',
      alignItems: 'center',
      height: 64,
      [theme.breakpoints.down('lg')]: {
        paddingInlineStart: 0,

      }
    },
    signOutButton: {
      marginLeft: theme.spacing(1),
    },
    logoLight: {
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        backgroundImage:
          'linear-gradient(to left,rgba(255, 255, 255, 0.3) 0% , rgb(255 255 255) 50%, rgba(255, 255, 255, 0.3) 100%)',
        display: 'block',
        content: `" "`,
        height: '100%',
        right: '-75%',
        position: 'absolute',
        animation: `shine 4s infinite ease`,
        top: '0',
        transform: 'skewX(-25deg)',
        width: '50%',
        zIndex: '2',
      },
    },

    logo: {
      height: 41,
      marginTop: 5,
      position: 'relative',

      backgroundPosition: '10px 0',
      [theme.breakpoints.down('md')]: {
        width: 35,
        height: 40,
      },

      '&:focus:after': {
        display: 'none',
        borderBottom: `2px solid ${theme.palette.primary.main}`,
      },
    },

    logoContainer: {
      width: 250,
    },
    respLogoContainer: {
      flex: 2,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    menuIconContainer: {
      width: '30vw',
    },
    panelTitle: {
      color: '#37474f',
      fontSize: 16,
      fontWeight: 500,
      paddingInlineStart: theme.spacing(2),
    },
    viewSiteButton: {
      marginInlineEnd: theme.spacing(1),
      border: 'none',
      background: theme.palette.primary.light,
      overflowWrap: 'break-word',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      '&:hover': {
        background: theme.palette.primary.light,
        border: 'none',
      },
    },
    viewMainSiteA: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
  };
});
